module.exports = __webpack_public_path__ + "static/media/iphone.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/iphone.png
// module id = 65
// module chunks = 0